<template>
  <div>
    <div id="body">
      <div class="wrapper" v-loading="contentLoading" id="pdfDom">
        <span id="pdfDomTitle" style="display: none"
          >{{ schoolInfo.name }}-高校导航详情导出</span
        >
        <div class="web-site">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">
              <i class="el-icon-location"></i>首页
            </el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/nav/school' }">
              高校导航
            </el-breadcrumb-item>
            <el-breadcrumb-item>{{ schoolInfo.name }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="wbox">
          <div class="wbox_content">
            <div class="pt-info">
              <dl>
                <dt>
                  <a href="javascript:void(0);">{{ schoolInfo.name }}</a>
                </dt>
                <dd class="pic">
                  <el-image
                    class="pic-logo"
                    :src="schoolInfo.logo"
                    :alt="schoolInfo.name"
                  >
                    <!-- <div
                      slot="error"
                      :class="'alt a' + Math.round(Math.random() * 4 + 1)"
                    > -->
                    <div slot="error" class="alt a1">
                      <span class="cn">
                        {{ replaceCompanyName(schoolInfo.name) }}
                      </span>
                    </div>
                  </el-image>
                </dd>
                <dd class="op">
                  <!-- <el-button size="mini" type="primary">关注</el-button> -->
                </dd>
                <dd class="intro">
                  <span v-if="schoolDetail && schoolDetail.adcode">
                    <span class="label">行政区划代码：</span>
                    {{ schoolDetail.adcode }}
                  </span>
                </dd>
                <dd class="d1" v-if="schoolDetail && schoolDetail.url">
                  <span class="label">网址：</span>
                  <a :href="schoolDetail.url" target="_blank">学校官网</a>
                </dd>
                <dd class="d1" v-if="schoolDetail && schoolDetail.address">
                  <span class="label">地址：</span>{{ schoolDetail.address }}
                </dd>
                <dd class="d2">
                  <div
                    class="introduction"
                    :style="introShow ? 'white-space: normal;' : ''"
                  >
                    <span class="label">简介：</span>
                    {{
                      schoolDetail && schoolDetail.intro
                        ? schoolDetail.intro
                        : ""
                    }}
                  </div>
                  <div class="btn">
                    <el-button
                      @click="introShow = !introShow"
                      class="btn-more"
                      :icon="
                        introShow ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
                      "
                      type="text"
                    >
                      <template v-if="!introShow">展开</template>
                      <template v-else>收起</template>
                    </el-button>
                  </div>
                </dd>
              </dl>
            </div>
            <div class="pt-content">
              <div class="inner-title" id="catalogContent0">
                <h4>基本信息</h4>
              </div>
              <div class="base-info">
                <div class="base-info_list">
                  <template v-for="(item, key, index) in schoolDetail">
                    <div
                      class="base-info_item"
                      :key="key"
                      v-if="excludeKeys.indexOf(key) < 0 && index % 2 === 0"
                    >
                      <span class="label">{{ key }}：</span>
                      {{ item }}
                    </div>
                  </template>
                </div>
                <div class="base-info_list">
                  <template v-for="(item, key, index) in schoolDetail">
                    <div
                      class="base-info_item"
                      :key="key"
                      v-if="excludeKeys.indexOf(key) < 0 && index % 2 > 0"
                    >
                      <span class="label">{{ key }}：</span>
                      {{ item }}
                    </div>
                  </template>
                </div>
              </div>

              <div class="inner-title" id="catalogContent1">
                <h4>高校成果</h4>
              </div>
              <div>
                <div
                  style="width: 800px; height: 500px; margin: 0 auto"
                  id="chartsPatent"
                ></div>
              </div>

              <div class="inner-title" id="catalogContent2">
                <h4>高校专利</h4>
              </div>
              <div
                class="guid-content"
                v-if="patentResults && patentResults.length > 0"
              >
                <el-table :data="patentResults" border style="width: 100%">
                  <el-table-column
                    type="index"
                    :index="patentIndexMethod"
                    label="序号"
                    width="80"
                  ></el-table-column>
                  <el-table-column
                    prop="title"
                    label="专利名称"
                  ></el-table-column>
                  <el-table-column
                    prop="pubnumber"
                    label="公布/公告号"
                    width="200"
                  >
                    <template slot-scope="scope">
                      {{ scope.row.pubnumber[0] }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="pattypeText"
                    label="专利类型"
                    width="150"
                  ></el-table-column>
                  <el-table-column
                    prop="pubdate"
                    label="公布/公告日期"
                    width="120"
                  >
                    <template slot-scope="scope">
                      {{ formatDate(scope.row.pubdate) }}
                    </template>
                  </el-table-column>
                  <!-- <el-table-column prop="id" label="操作" width="50">
                  <template slot-scope="scope">
                    <el-link
                      type="primary"
                      :href="'/patent_detail?id=' + scope.row.id"
                      target="_blank"
                      >详情</el-link
                    >
                  </template>
                </el-table-column> -->
                </el-table>
                <div style="text-align: right; margin-top: 10px">
                  <el-pagination
                    size
                    @current-change="handlePatentCurrentChange"
                    :current-page="patentPageIndex"
                    :page-size="patentPageSize"
                    layout="prev, pager, next, jumper"
                    :total="patentTotal"
                  >
                  </el-pagination>
                </div>
              </div>
              <div
                class="no-data"
                v-if="!patentResults || patentResults.length === 0"
              >
                <div class="tip">
                  <svg
                    t="1626241932884"
                    class="icon"
                    viewBox="0 0 1428 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="2321"
                    width="60"
                    height="60"
                  >
                    <path
                      d="M982.129778 353.975309H572.833185C556.689383 353.975309 543.604938 339.854222 543.604938 322.37037s13.071802-31.604938 29.240889-31.604938h409.271309C998.311506 290.765432 1011.358025 304.886519 1011.358025 322.37037S998.286222 353.975309 982.117136 353.975309M982.129778 467.753086H572.833185C556.689383 467.753086 543.604938 453.632 543.604938 436.148148s13.071802-31.604938 29.240889-31.604938h409.271309C998.311506 404.54321 1011.358025 418.664296 1011.358025 436.148148S998.286222 467.753086 982.117136 467.753086M805.293827 594.17284H572.681481c-16.080593 0-29.076543-14.121086-29.076543-31.604939s12.995951-31.604938 29.076543-31.604938h232.612346c16.080593 0 29.076543 14.121086 29.076543 31.604938S821.37442 594.17284 805.293827 594.17284"
                      p-id="2322"
                    ></path>
                    <path
                      d="M501.304889 173.675457c-12.995951 0-23.627852 10.49284-23.627852 23.400296v743.626272c0 12.894815 10.631901 23.387654 23.640494 23.387654h602.895802c13.033877 0 23.640494-10.49284 23.640494-23.387654V197.075753c0-12.894815-10.606617-23.387654-23.640494-23.387654h-602.895802zM1104.225975 1024H501.304889C454.934123 1024 417.185185 986.642963 417.185185 940.689383V197.088395C417.185185 151.122173 454.934123 113.777778 501.304889 113.777778h602.921086C1150.622025 113.777778 1188.345679 151.134815 1188.345679 197.088395v743.600988c0 45.95358-37.723654 83.310617-84.119704 83.310617z"
                      p-id="2323"
                    ></path>
                    <path
                      d="M1216.840691 910.222222h-68.54479v-59.897679h68.54479c13.451062 0 24.778272-10.214716 24.778272-22.287802V82.17284c0-12.073086-11.32721-22.287802-24.778272-22.287803H616.245728c-13.451062 0-24.778272 10.214716-24.778271 22.287803v65.068246H530.962963V82.17284C530.962963 36.851358 569.21758 0 616.245728 0h600.594963C1263.86884 0 1302.123457 36.851358 1302.123457 82.185481V828.049383C1302.123457 873.370864 1263.86884 910.222222 1216.840691 910.222222"
                      p-id="2324"
                    ></path>
                    <path
                      d="M1399.049481 910.222222H1192.555457C1176.247309 910.222222 1163.061728 896.088494 1163.061728 878.617284s13.18558-31.604938 29.493729-31.604938h206.494024c16.308148 0 29.493728 14.133728 29.493729 31.604938s-13.18558 31.604938-29.493729 31.604938M514.528395 1024H281.916049c-16.080593 0-29.076543-14.133728-29.076543-31.604938s12.995951-31.604938 29.076543-31.604939h232.612346c16.080593 0 29.076543 14.133728 29.076543 31.604939S530.608988 1024 514.528395 1024M173.372049 1024H28.899556C12.920099 1024 0 1009.866272 0 992.395062S12.920099 960.790123 28.899556 960.790123h144.472493C189.351506 960.790123 202.271605 974.923852 202.271605 992.395062S189.351506 1024 173.372049 1024M326.580148 50.567901h-58.987457C259.451259 50.567901 252.839506 44.904296 252.839506 37.925926s6.611753-12.641975 14.753185-12.641975h58.987457C334.72158 25.283951 341.333333 30.947556 341.333333 37.925926s-6.611753 12.641975-14.753185 12.641975"
                      p-id="2325"
                    ></path>
                    <path
                      d="M290.765432 88.493827c-6.97837 0-12.641975-6.611753-12.641975-14.753185V14.753185C278.123457 6.611753 283.787062 0 290.765432 0s12.641975 6.611753 12.641975 14.753185v58.987457C303.407407 81.882074 297.743802 88.493827 290.765432 88.493827M273.901037 480.395062h-67.407012C197.176889 480.395062 189.62963 471.924938 189.62963 461.432099s7.547259-18.962963 16.864395-18.962963h67.407012c9.317136 0 16.864395 8.470123 16.864395 18.962963s-7.547259 18.962963-16.864395 18.962963"
                      p-id="2326"
                    ></path>
                    <path
                      d="M233.876543 505.679012c-10.49284 0-18.962963-7.547259-18.962963-16.864395v-67.407012c0-9.317136 8.470123-16.864395 18.962963-16.864395s18.962963 7.547259 18.962963 16.864395v67.407012c0 9.317136-8.470123 16.864395-18.962963 16.864395M132.740741 142.222222a28.444444 28.444444 0 1 0 0.025284 56.914173 28.444444 28.444444 0 0 0-0.025284-56.914173m0 85.333334A56.952099 56.952099 0 0 1 75.851852 170.666667C75.851852 139.289284 101.363358 113.777778 132.740741 113.777778s56.888889 25.511506 56.888889 56.888889-25.511506 56.888889-56.888889 56.888889M1384.296296 231.765333a14.791111 14.791111 0 0 0-14.753185 14.753186 14.791111 14.791111 0 0 0 14.753185 14.753185 14.791111 14.791111 0 0 0 14.753185-14.753185 14.791111 14.791111 0 0 0-14.753185-14.753186m0 59.000099c-24.399012 0-44.246914-19.847901-44.246913-44.246913s19.847901-44.246914 44.246913-44.246914 44.246914 19.847901 44.246914 44.246914-19.847901 44.246914-44.246914 44.246913"
                      p-id="2327"
                    ></path>
                  </svg>
                  <div class="text">暂无数据</div>
                </div>
              </div>

              <div class="inner-title" id="catalogContent3">
                <h4>核心人才</h4>
              </div>
              <div v-if="inventorFacetData && inventorFacetData.length > 0">
                <div class="html-chat">
                  <!--tag font-szie 代表 大小 最小20 最大100-->
                  <div
                    class="canvas"
                    style="width: 800px; min-height: 100px; margin: 0 auto"
                  >
                    <div class="yAxis" style="min-height: 100px">
                      <div
                        class="axis"
                        v-for="(item, index) in inventorFacetData"
                        :key="index"
                      >
                        <label>{{ item.year }}</label>
                        <el-tooltip
                          popper-class="chat-tip"
                          effect="light"
                          placement="right"
                          v-for="(inventor, inventorIndex) in item.data"
                          :key="inventorIndex"
                        >
                          <div slot="content">
                            <span>
                              {{ inventor.text }}&nbsp;{{ item.year }}年：{{
                                inventor.count
                              }}条专利
                            </span>
                          </div>
                          <el-tag
                            :type="inventorFacetClass[index]"
                            :style="
                              'font-size:' +
                              (inventor.count < 12 ? 12 : inventor.count) +
                              'px'
                            "
                          >
                            <span>{{ inventor.text }}</span>
                          </el-tag>
                        </el-tooltip>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="no-data"
                v-if="!inventorFacetData || inventorFacetData.length === 0"
              >
                <div class="tip">
                  <svg
                    t="1626241932884"
                    class="icon"
                    viewBox="0 0 1428 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="2321"
                    width="60"
                    height="60"
                  >
                    <path
                      d="M982.129778 353.975309H572.833185C556.689383 353.975309 543.604938 339.854222 543.604938 322.37037s13.071802-31.604938 29.240889-31.604938h409.271309C998.311506 290.765432 1011.358025 304.886519 1011.358025 322.37037S998.286222 353.975309 982.117136 353.975309M982.129778 467.753086H572.833185C556.689383 467.753086 543.604938 453.632 543.604938 436.148148s13.071802-31.604938 29.240889-31.604938h409.271309C998.311506 404.54321 1011.358025 418.664296 1011.358025 436.148148S998.286222 467.753086 982.117136 467.753086M805.293827 594.17284H572.681481c-16.080593 0-29.076543-14.121086-29.076543-31.604939s12.995951-31.604938 29.076543-31.604938h232.612346c16.080593 0 29.076543 14.121086 29.076543 31.604938S821.37442 594.17284 805.293827 594.17284"
                      p-id="2322"
                    ></path>
                    <path
                      d="M501.304889 173.675457c-12.995951 0-23.627852 10.49284-23.627852 23.400296v743.626272c0 12.894815 10.631901 23.387654 23.640494 23.387654h602.895802c13.033877 0 23.640494-10.49284 23.640494-23.387654V197.075753c0-12.894815-10.606617-23.387654-23.640494-23.387654h-602.895802zM1104.225975 1024H501.304889C454.934123 1024 417.185185 986.642963 417.185185 940.689383V197.088395C417.185185 151.122173 454.934123 113.777778 501.304889 113.777778h602.921086C1150.622025 113.777778 1188.345679 151.134815 1188.345679 197.088395v743.600988c0 45.95358-37.723654 83.310617-84.119704 83.310617z"
                      p-id="2323"
                    ></path>
                    <path
                      d="M1216.840691 910.222222h-68.54479v-59.897679h68.54479c13.451062 0 24.778272-10.214716 24.778272-22.287802V82.17284c0-12.073086-11.32721-22.287802-24.778272-22.287803H616.245728c-13.451062 0-24.778272 10.214716-24.778271 22.287803v65.068246H530.962963V82.17284C530.962963 36.851358 569.21758 0 616.245728 0h600.594963C1263.86884 0 1302.123457 36.851358 1302.123457 82.185481V828.049383C1302.123457 873.370864 1263.86884 910.222222 1216.840691 910.222222"
                      p-id="2324"
                    ></path>
                    <path
                      d="M1399.049481 910.222222H1192.555457C1176.247309 910.222222 1163.061728 896.088494 1163.061728 878.617284s13.18558-31.604938 29.493729-31.604938h206.494024c16.308148 0 29.493728 14.133728 29.493729 31.604938s-13.18558 31.604938-29.493729 31.604938M514.528395 1024H281.916049c-16.080593 0-29.076543-14.133728-29.076543-31.604938s12.995951-31.604938 29.076543-31.604939h232.612346c16.080593 0 29.076543 14.133728 29.076543 31.604939S530.608988 1024 514.528395 1024M173.372049 1024H28.899556C12.920099 1024 0 1009.866272 0 992.395062S12.920099 960.790123 28.899556 960.790123h144.472493C189.351506 960.790123 202.271605 974.923852 202.271605 992.395062S189.351506 1024 173.372049 1024M326.580148 50.567901h-58.987457C259.451259 50.567901 252.839506 44.904296 252.839506 37.925926s6.611753-12.641975 14.753185-12.641975h58.987457C334.72158 25.283951 341.333333 30.947556 341.333333 37.925926s-6.611753 12.641975-14.753185 12.641975"
                      p-id="2325"
                    ></path>
                    <path
                      d="M290.765432 88.493827c-6.97837 0-12.641975-6.611753-12.641975-14.753185V14.753185C278.123457 6.611753 283.787062 0 290.765432 0s12.641975 6.611753 12.641975 14.753185v58.987457C303.407407 81.882074 297.743802 88.493827 290.765432 88.493827M273.901037 480.395062h-67.407012C197.176889 480.395062 189.62963 471.924938 189.62963 461.432099s7.547259-18.962963 16.864395-18.962963h67.407012c9.317136 0 16.864395 8.470123 16.864395 18.962963s-7.547259 18.962963-16.864395 18.962963"
                      p-id="2326"
                    ></path>
                    <path
                      d="M233.876543 505.679012c-10.49284 0-18.962963-7.547259-18.962963-16.864395v-67.407012c0-9.317136 8.470123-16.864395 18.962963-16.864395s18.962963 7.547259 18.962963 16.864395v67.407012c0 9.317136-8.470123 16.864395-18.962963 16.864395M132.740741 142.222222a28.444444 28.444444 0 1 0 0.025284 56.914173 28.444444 28.444444 0 0 0-0.025284-56.914173m0 85.333334A56.952099 56.952099 0 0 1 75.851852 170.666667C75.851852 139.289284 101.363358 113.777778 132.740741 113.777778s56.888889 25.511506 56.888889 56.888889-25.511506 56.888889-56.888889 56.888889M1384.296296 231.765333a14.791111 14.791111 0 0 0-14.753185 14.753186 14.791111 14.791111 0 0 0 14.753185 14.753185 14.791111 14.791111 0 0 0 14.753185-14.753185 14.791111 14.791111 0 0 0-14.753185-14.753186m0 59.000099c-24.399012 0-44.246914-19.847901-44.246913-44.246913s19.847901-44.246914 44.246913-44.246914 44.246914 19.847901 44.246914 44.246914-19.847901 44.246914-44.246914 44.246913"
                      p-id="2327"
                    ></path>
                  </svg>
                  <div class="text">暂无数据</div>
                </div>
              </div>

              <div class="inner-title" id="catalogContent4">
                <h4>产学研合作</h4>
              </div>
              <div>
                <div
                  style="width: 800px; height: 600px; margin: 0 auto"
                  id="chartsCxy"
                >
                  <div class="no-data">
                    <div class="tip">
                      <svg
                        t="1626241932884"
                        class="icon"
                        viewBox="0 0 1428 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="2321"
                        width="60"
                        height="60"
                      >
                        <path
                          d="M982.129778 353.975309H572.833185C556.689383 353.975309 543.604938 339.854222 543.604938 322.37037s13.071802-31.604938 29.240889-31.604938h409.271309C998.311506 290.765432 1011.358025 304.886519 1011.358025 322.37037S998.286222 353.975309 982.117136 353.975309M982.129778 467.753086H572.833185C556.689383 467.753086 543.604938 453.632 543.604938 436.148148s13.071802-31.604938 29.240889-31.604938h409.271309C998.311506 404.54321 1011.358025 418.664296 1011.358025 436.148148S998.286222 467.753086 982.117136 467.753086M805.293827 594.17284H572.681481c-16.080593 0-29.076543-14.121086-29.076543-31.604939s12.995951-31.604938 29.076543-31.604938h232.612346c16.080593 0 29.076543 14.121086 29.076543 31.604938S821.37442 594.17284 805.293827 594.17284"
                          p-id="2322"
                        ></path>
                        <path
                          d="M501.304889 173.675457c-12.995951 0-23.627852 10.49284-23.627852 23.400296v743.626272c0 12.894815 10.631901 23.387654 23.640494 23.387654h602.895802c13.033877 0 23.640494-10.49284 23.640494-23.387654V197.075753c0-12.894815-10.606617-23.387654-23.640494-23.387654h-602.895802zM1104.225975 1024H501.304889C454.934123 1024 417.185185 986.642963 417.185185 940.689383V197.088395C417.185185 151.122173 454.934123 113.777778 501.304889 113.777778h602.921086C1150.622025 113.777778 1188.345679 151.134815 1188.345679 197.088395v743.600988c0 45.95358-37.723654 83.310617-84.119704 83.310617z"
                          p-id="2323"
                        ></path>
                        <path
                          d="M1216.840691 910.222222h-68.54479v-59.897679h68.54479c13.451062 0 24.778272-10.214716 24.778272-22.287802V82.17284c0-12.073086-11.32721-22.287802-24.778272-22.287803H616.245728c-13.451062 0-24.778272 10.214716-24.778271 22.287803v65.068246H530.962963V82.17284C530.962963 36.851358 569.21758 0 616.245728 0h600.594963C1263.86884 0 1302.123457 36.851358 1302.123457 82.185481V828.049383C1302.123457 873.370864 1263.86884 910.222222 1216.840691 910.222222"
                          p-id="2324"
                        ></path>
                        <path
                          d="M1399.049481 910.222222H1192.555457C1176.247309 910.222222 1163.061728 896.088494 1163.061728 878.617284s13.18558-31.604938 29.493729-31.604938h206.494024c16.308148 0 29.493728 14.133728 29.493729 31.604938s-13.18558 31.604938-29.493729 31.604938M514.528395 1024H281.916049c-16.080593 0-29.076543-14.133728-29.076543-31.604938s12.995951-31.604938 29.076543-31.604939h232.612346c16.080593 0 29.076543 14.133728 29.076543 31.604939S530.608988 1024 514.528395 1024M173.372049 1024H28.899556C12.920099 1024 0 1009.866272 0 992.395062S12.920099 960.790123 28.899556 960.790123h144.472493C189.351506 960.790123 202.271605 974.923852 202.271605 992.395062S189.351506 1024 173.372049 1024M326.580148 50.567901h-58.987457C259.451259 50.567901 252.839506 44.904296 252.839506 37.925926s6.611753-12.641975 14.753185-12.641975h58.987457C334.72158 25.283951 341.333333 30.947556 341.333333 37.925926s-6.611753 12.641975-14.753185 12.641975"
                          p-id="2325"
                        ></path>
                        <path
                          d="M290.765432 88.493827c-6.97837 0-12.641975-6.611753-12.641975-14.753185V14.753185C278.123457 6.611753 283.787062 0 290.765432 0s12.641975 6.611753 12.641975 14.753185v58.987457C303.407407 81.882074 297.743802 88.493827 290.765432 88.493827M273.901037 480.395062h-67.407012C197.176889 480.395062 189.62963 471.924938 189.62963 461.432099s7.547259-18.962963 16.864395-18.962963h67.407012c9.317136 0 16.864395 8.470123 16.864395 18.962963s-7.547259 18.962963-16.864395 18.962963"
                          p-id="2326"
                        ></path>
                        <path
                          d="M233.876543 505.679012c-10.49284 0-18.962963-7.547259-18.962963-16.864395v-67.407012c0-9.317136 8.470123-16.864395 18.962963-16.864395s18.962963 7.547259 18.962963 16.864395v67.407012c0 9.317136-8.470123 16.864395-18.962963 16.864395M132.740741 142.222222a28.444444 28.444444 0 1 0 0.025284 56.914173 28.444444 28.444444 0 0 0-0.025284-56.914173m0 85.333334A56.952099 56.952099 0 0 1 75.851852 170.666667C75.851852 139.289284 101.363358 113.777778 132.740741 113.777778s56.888889 25.511506 56.888889 56.888889-25.511506 56.888889-56.888889 56.888889M1384.296296 231.765333a14.791111 14.791111 0 0 0-14.753185 14.753186 14.791111 14.791111 0 0 0 14.753185 14.753185 14.791111 14.791111 0 0 0 14.753185-14.753185 14.791111 14.791111 0 0 0-14.753185-14.753186m0 59.000099c-24.399012 0-44.246914-19.847901-44.246913-44.246913s19.847901-44.246914 44.246913-44.246914 44.246914 19.847901 44.246914 44.246914-19.847901 44.246914-44.246914 44.246913"
                          p-id="2327"
                        ></path>
                      </svg>
                      <div class="text">暂无数据</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="inner-title" id="catalogContent5">
                <h4>数据情报</h4>
              </div>
              <div class="search-result-list">
                <div
                  class="data-list"
                  v-infinite-scroll="
                    () => {
                      handleQingbaoCurrentChange();
                    }
                  "
                >
                  <dl v-for="(item, index) in qingbaoResults" :key="index">
                    <dt>
                      <span
                        v-html="
                          item.picTitle.replace(
                            /[图表]+?[\d-]{0,6}[:：\s\.]+/g,
                            ''
                          )
                        "
                      ></span>
                      <span v-if="showNewTab(item.date)" class="status s-new"
                        >上新</span
                      >
                    </dt>
                    <dd class="pic">
                      <el-image
                        :src="item.picPath"
                        @click="showImgViewer(index)"
                        lazy
                      >
                        <div slot="error" style="margin-top: -120px">
                          <i class="el-icon-picture-outline"></i>
                        </div>
                      </el-image>
                    </dd>
                    <dd class="info">
                      <span class="t">{{ dateFormat(item.date, "date") }}</span>
                      <span class="o">
                        <span
                          v-for="(industry, index) in item.industry"
                          :key="index"
                          v-html="industry"
                        ></span
                      ></span>
                    </dd>
                    <dd class="bottom">
                      <el-tag v-if="item.picType && item.picType.length > 0">
                        <img src="~@/assets/images/icon-tag.png" alt="" />
                        <span
                          v-for="(picType, index) in item.picType"
                          :key="index"
                        >
                          {{ (index > 0 ? "| " : "") + picType }}
                        </span>
                      </el-tag>
                      <el-button
                        size="small"
                        @click="viewPath(item.id, item.picPath, item.title)"
                        v-if="
                          item.pdfPath &&
                          item.pdfPath.substring(
                            item.pdfPath.lastIndexOf('.')
                          ) === '.pdf'
                        "
                      >
                        <img
                          src="~@/assets/images/icon-view.png"
                          alt=""
                        />查看原文
                        <!-- <el-link :href="item.pdfPath" target="_blank">
                    <img src="~@/assets/images/icon-view.png" alt="" />查看原文
                  </el-link> -->
                      </el-button>
                      <el-button
                        size="small"
                        @click="
                          handleDownload(
                            item.id,
                            item.title,
                            item.pdfPath.substring(
                              item.pdfPath.lastIndexOf('.')
                            )
                          )
                        "
                        v-else
                      >
                        <img
                          src="~@/assets/images/icon-view.png"
                          alt=""
                        />查看原文
                        <!-- <el-link :href="item.pdfPath" target="_blank">
                    <img src="~@/assets/images/icon-view.png" alt="" />查看原文
                  </el-link> -->
                      </el-button>
                    </dd>
                  </dl>

                  <div
                    class="no-data"
                    v-if="!qingbaoResults || qingbaoResults.length === 0"
                  >
                    <div class="tip">
                      <svg
                        t="1626241932884"
                        class="icon"
                        viewBox="0 0 1428 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="2321"
                        width="60"
                        height="60"
                      >
                        <path
                          d="M982.129778 353.975309H572.833185C556.689383 353.975309 543.604938 339.854222 543.604938 322.37037s13.071802-31.604938 29.240889-31.604938h409.271309C998.311506 290.765432 1011.358025 304.886519 1011.358025 322.37037S998.286222 353.975309 982.117136 353.975309M982.129778 467.753086H572.833185C556.689383 467.753086 543.604938 453.632 543.604938 436.148148s13.071802-31.604938 29.240889-31.604938h409.271309C998.311506 404.54321 1011.358025 418.664296 1011.358025 436.148148S998.286222 467.753086 982.117136 467.753086M805.293827 594.17284H572.681481c-16.080593 0-29.076543-14.121086-29.076543-31.604939s12.995951-31.604938 29.076543-31.604938h232.612346c16.080593 0 29.076543 14.121086 29.076543 31.604938S821.37442 594.17284 805.293827 594.17284"
                          p-id="2322"
                        ></path>
                        <path
                          d="M501.304889 173.675457c-12.995951 0-23.627852 10.49284-23.627852 23.400296v743.626272c0 12.894815 10.631901 23.387654 23.640494 23.387654h602.895802c13.033877 0 23.640494-10.49284 23.640494-23.387654V197.075753c0-12.894815-10.606617-23.387654-23.640494-23.387654h-602.895802zM1104.225975 1024H501.304889C454.934123 1024 417.185185 986.642963 417.185185 940.689383V197.088395C417.185185 151.122173 454.934123 113.777778 501.304889 113.777778h602.921086C1150.622025 113.777778 1188.345679 151.134815 1188.345679 197.088395v743.600988c0 45.95358-37.723654 83.310617-84.119704 83.310617z"
                          p-id="2323"
                        ></path>
                        <path
                          d="M1216.840691 910.222222h-68.54479v-59.897679h68.54479c13.451062 0 24.778272-10.214716 24.778272-22.287802V82.17284c0-12.073086-11.32721-22.287802-24.778272-22.287803H616.245728c-13.451062 0-24.778272 10.214716-24.778271 22.287803v65.068246H530.962963V82.17284C530.962963 36.851358 569.21758 0 616.245728 0h600.594963C1263.86884 0 1302.123457 36.851358 1302.123457 82.185481V828.049383C1302.123457 873.370864 1263.86884 910.222222 1216.840691 910.222222"
                          p-id="2324"
                        ></path>
                        <path
                          d="M1399.049481 910.222222H1192.555457C1176.247309 910.222222 1163.061728 896.088494 1163.061728 878.617284s13.18558-31.604938 29.493729-31.604938h206.494024c16.308148 0 29.493728 14.133728 29.493729 31.604938s-13.18558 31.604938-29.493729 31.604938M514.528395 1024H281.916049c-16.080593 0-29.076543-14.133728-29.076543-31.604938s12.995951-31.604938 29.076543-31.604939h232.612346c16.080593 0 29.076543 14.133728 29.076543 31.604939S530.608988 1024 514.528395 1024M173.372049 1024H28.899556C12.920099 1024 0 1009.866272 0 992.395062S12.920099 960.790123 28.899556 960.790123h144.472493C189.351506 960.790123 202.271605 974.923852 202.271605 992.395062S189.351506 1024 173.372049 1024M326.580148 50.567901h-58.987457C259.451259 50.567901 252.839506 44.904296 252.839506 37.925926s6.611753-12.641975 14.753185-12.641975h58.987457C334.72158 25.283951 341.333333 30.947556 341.333333 37.925926s-6.611753 12.641975-14.753185 12.641975"
                          p-id="2325"
                        ></path>
                        <path
                          d="M290.765432 88.493827c-6.97837 0-12.641975-6.611753-12.641975-14.753185V14.753185C278.123457 6.611753 283.787062 0 290.765432 0s12.641975 6.611753 12.641975 14.753185v58.987457C303.407407 81.882074 297.743802 88.493827 290.765432 88.493827M273.901037 480.395062h-67.407012C197.176889 480.395062 189.62963 471.924938 189.62963 461.432099s7.547259-18.962963 16.864395-18.962963h67.407012c9.317136 0 16.864395 8.470123 16.864395 18.962963s-7.547259 18.962963-16.864395 18.962963"
                          p-id="2326"
                        ></path>
                        <path
                          d="M233.876543 505.679012c-10.49284 0-18.962963-7.547259-18.962963-16.864395v-67.407012c0-9.317136 8.470123-16.864395 18.962963-16.864395s18.962963 7.547259 18.962963 16.864395v67.407012c0 9.317136-8.470123 16.864395-18.962963 16.864395M132.740741 142.222222a28.444444 28.444444 0 1 0 0.025284 56.914173 28.444444 28.444444 0 0 0-0.025284-56.914173m0 85.333334A56.952099 56.952099 0 0 1 75.851852 170.666667C75.851852 139.289284 101.363358 113.777778 132.740741 113.777778s56.888889 25.511506 56.888889 56.888889-25.511506 56.888889-56.888889 56.888889M1384.296296 231.765333a14.791111 14.791111 0 0 0-14.753185 14.753186 14.791111 14.791111 0 0 0 14.753185 14.753185 14.791111 14.791111 0 0 0 14.753185-14.753185 14.791111 14.791111 0 0 0-14.753185-14.753186m0 59.000099c-24.399012 0-44.246914-19.847901-44.246913-44.246913s19.847901-44.246914 44.246913-44.246914 44.246914 19.847901 44.246914 44.246914-19.847901 44.246914-44.246914 44.246913"
                          p-id="2327"
                        ></path>
                      </svg>
                      <div class="text">暂无数据</div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="catalog" id="catalog">
                <ul>
                  <li
                    :class="catalogActive === 0 ? 'is-active' : ''"
                    @click="handleScrollIntoView(0)"
                  >
                    基本信息
                  </li>
                  <li
                    :class="catalogActive === 1 ? 'is-active' : ''"
                    @click="handleScrollIntoView(1)"
                  >
                    高校成果
                  </li>
                  <li
                    :class="catalogActive === 2 ? 'is-active' : ''"
                    @click="handleScrollIntoView(2)"
                  >
                    高校专利
                  </li>
                  <li
                    :class="catalogActive === 3 ? 'is-active' : ''"
                    @click="handleScrollIntoView(3)"
                  >
                    核心人才
                  </li>
                  <li
                    :class="catalogActive === 4 ? 'is-active' : ''"
                    @click="handleScrollIntoView(4)"
                  >
                    产学研合作
                  </li>
                  <li
                    :class="catalogActive === 5 ? 'is-active' : ''"
                    @click="handleScrollIntoView(5)"
                  >
                    数据情报
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="imgViewerVisible">
      <el-image-viewer
        :on-close="closeImgViewer"
        :url-list="imgList"
        :initialIndex="imgViewerIndex"
        :onSwitch="imgViewerOnSwitch"
      />
      <div class="img-viewer-title">
        <h3 v-html="getReportTitle()"></h3>
      </div>
      <div class="img-viewer-download">
        <span
          class="el-image-viewer__btn el-image-viewer__next"
          @click="downloadImg"
        >
          <i class="el-icon-download"></i>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { axiosOptions, axiosRequest } from "../../util/request";
import moment from "moment";
import * as echarts from "echarts";
import {
  downloadReport,
  downloadDataIntelligenceImg,
  updateLoginUserInfo,
} from "../../util/utils";

export default {
  components: {
    "el-image-viewer": () =>
      import("element-ui/packages/image/src/image-viewer"),
  },
  data() {
    return {
      introShow: false,
      activeName: "jibenxinxi",
      id: this.$route.query.id || 0,
      contentLoading: false,
      schoolInfo: {},
      schoolDetail: {},

      tabLoading: false,
      industry: {},
      university: {},
      tagList: [],
      patentFacets: [],

      patentResults: [],
      patentTotal: 0,
      patentPageIndex: 1,
      patentPageSize: 10,

      excludeKeys: [
        "adname",
        "orgname",
        "province",
        "intro",
        "address",
        "adcode",
        "cityname",
        "url",
        "baike_url",
      ],

      catalogActive: 0,
      articleYearsFacet: [],
      patentYearsFacet: [],

      qingbaoResults: [],
      qingbaoPageIndex: 0,
      qingbaoPageSize: 4,
      qingbaoPageCount: -1,
      imgViewerVisible: false,
      imgList: [],
      imgViewerIndex: 0,

      inventorFacetData: [],
      inventorFacetClass: ["", "success", "warning", "info", "danger"],
    };
  },
  created() {
    // mounted() {
    if (!this.id) {
      this.$router.push("/");
    }

    this.getCompanyInfo().then(() => {
      const that = this;
      that.tabLoading = true;

      const promisePatent = new Promise((resolve, reject) => {
        that.getCompanyPatent().then(() => {
          resolve(true);
        });
      });

      const promiseArticleYearsFacet = new Promise((resolve, reject) => {
        that.getArticleYearsFacet().then(() => {
          resolve(true);
        });
      });
      const promisePatentYearsFacet = new Promise((resolve, reject) => {
        that.getPatentYearsFacet().then(() => {
          resolve(true);
        });
      });
      Promise.all([promiseArticleYearsFacet, promisePatentYearsFacet]).then(
        () => {
          let years = this.patentYearsFacet.map((item) => item.text);
          if (!years) {
            years = [];
          }

          let articleYears = [];
          if (this.articleYearsFacet && this.articleYearsFacet.length > 0) {
            articleYears = this.articleYearsFacet.map((item) => item.name);
          }
          if (articleYears && articleYears.length > 0) {
            articleYears.forEach((year) => {
              if (years.findIndex((item) => item === year) < 0) {
                years.push(year);
              }
            });
          }
          years = years.sort((a, b) => a - b);

          let patentData = [],
            articleData = [];
          if (years && years.length > 0) {
            years = years.sort((a, b) => a - b);
            years.forEach((year) => {
              let patent = this.patentYearsFacet.find(
                (item) => item.text === year
              );
              if (patent) {
                patentData.push(patent.count);
              } else {
                patentData.push(0);
              }

              let article = null;
              if (this.articleYearsFacet && this.articleYearsFacet.length > 0) {
                article = this.articleYearsFacet.find(
                  (item) => item.name === year
                );
              }
              if (article) {
                articleData.push(article.count);
              } else {
                articleData.push(0);
              }
            });
          }

          const myChart = echarts.init(document.getElementById("chartsPatent"));
          myChart.setOption({
            title: {
              text: "",
            },
            tooltip: {
              trigger: "axis",
            },
            grid: {
              right: "20%",
            },
            toolbox: {
              feature: {
                dataView: {
                  show: false,
                  readOnly: false,
                },
                restore: {
                  show: false,
                },
                saveAsImage: {
                  show: false,
                },
              },
            },
            legend: {
              data: ["期刊论文数量", "专利数量"],
            },
            xAxis: [
              {
                type: "category",
                axisTick: {
                  alignWithLabel: false,
                },
                data: years,
              },
            ],
            yAxis: [
              {
                type: "value",
                name: "期刊论文数量",
                // min: 0,
                // max: 11000,
                position: "left",
                axisLine: {
                  lineStyle: {},
                },
                axisLabel: {
                  formatter: "{value}",
                },
              },
              {
                type: "value",
                name: "专利数量",
                // min: 0,
                // max: 200,
                position: "right",
                axisLine: {
                  lineStyle: {},
                },
                axisLabel: {
                  formatter: "{value}",
                },
              },
            ],
            series: [
              {
                name: "期刊论文数量",
                type: "line",
                data: articleData,
                smooth: true,
              },
              {
                name: "专利数量",
                type: "line",
                yAxisIndex: 1,
                data: patentData,
                smooth: true,
              },
            ],
          });
        }
      );

      const promiseInventorFacet = new Promise((resolve, reject) => {
        that.getInventorFacet().then(() => {
          resolve(true);
        });
      });

      const promiseOrganList = new Promise((resolve, reject) => {
        that.getOrganList().then(() => {
          resolve(true);
        });
      });

      const promiseDataIntelligence = new Promise((resolve, reject) => {
        that.getDataIntelligence().then(() => {
          resolve(true);
        });
      });

      Promise.all([
        promisePatent,
        promiseInventorFacet,
        promiseOrganList,
        promiseDataIntelligence,
      ]).then(() => {
        that.tabLoading = false;
      });
    });

    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      for (let i = 0; i < 6; i++) {
        let element = document.getElementById("catalogContent" + i);
        if (element) {
          let top = element.getBoundingClientRect().top;
          if (top > 0) {
            this.catalogActive = i;
            return false;
          }
        }
      }
    },
    getReportTitle() {
      if (
        this.qingbaoResults &&
        this.qingbaoResults.length > this.imgViewerIndex
      ) {
        const item = this.qingbaoResults[this.imgViewerIndex];
        if (item && item.title) {
          return item.title;
        }
      }

      return "";
    },
    getCurrentPicTitle() {
      if (
        this.qingbaoResults &&
        this.qingbaoResults.length > this.imgViewerIndex
      ) {
        const item = this.qingbaoResults[this.imgViewerIndex];
        if (item && item.picTitle) {
          return item.picTitle
            .replace(/(<([^>]+)>)/gi, "")
            .replace(/[图表]+?[\d-]{0,6}[:：\s\.]+/g, "");
        }
      }

      return "";
    },
    viewPath(id, picPath, title) {
      let page = "";
      if (picPath) {
        let filename = picPath.substring(picPath.lastIndexOf("/") + 1);
        page = filename.substring(0, filename.indexOf("_"));
      }
      let url = this.$router.resolve({
        path: "/report/read",
        query: { id: id, type: 1, page: page, title: title },
      });
      window.open(url.href, "_blank");
    },
    showImgViewer(index) {
      document.documentElement.style.overflowY = "hidden";
      this.imgViewerIndex = index;
      this.imgViewerVisible = true;
    },
    closeImgViewer() {
      document.documentElement.style.overflowY = "auto";
      this.imgViewerVisible = false;
    },
    imgViewerOnSwitch(index) {
      this.imgViewerIndex = index;
    },
    downloadImg() {
      if (!this.qingbaoResults || this.qingbaoResults.length === 0) {
        return;
      }

      downloadDataIntelligenceImg(
        this.qingbaoResults[this.imgViewerIndex].id,
        this.getCurrentPicTitle()
      );
    },
    handleDownload(id, title, suffix) {
      downloadReport(1, id, title, suffix);
    },
    showNewTab(date) {
      return (new Date() - new Date(date)) / (60 * 60 * 1000) / 24 < 7;
    },
    showDeepTab(tabs) {
      return (
        tabs && tabs.length > 0 && tabs.some((item) => item === "深度研究")
      );
    },
    dateFormat(cellValue, type) {
      if (!cellValue) return "";
      if (type === "date") {
        return moment(cellValue).format("YYYY-MM-DD");
      }
      return moment(cellValue).format("YYYY-MM-DD HH:mm:ss");
    },
    handleQingbaoCurrentChange() {
      this.qingbaoPageIndex++;
      if (
        this.qingbaoPageCount === -1 ||
        (this.qingbaoPageIndex < 6 &&
          this.qingbaoPageIndex <= this.qingbaoPageCount)
      ) {
        this.getDataIntelligence().then(() => {});
      }
    },
    async getDataIntelligence() {
      if (!this.schoolInfo || !this.schoolInfo.name) {
        return;
      }

      await axiosRequest(
        "/search/nav-data-intelligence",
        {
          text: this.schoolInfo.name,
          type: 1,
          pageIndex: this.qingbaoPageIndex,
        },
        axiosOptions("post", "", "json")
      )
        .then((res) => {
          if (res && res.data.code === 200) {
            // this.qingbaoResults = res.data.data.records;
            res.data.data.records.forEach((element) => {
              this.qingbaoResults.push(element);
            });
            this.qingbaoPageCount = res.data.data.pages;
            this.imgList = this.qingbaoResults.map((i) => {
              return i.picPath;
            });
          }
        })
        .catch(() => {});
    },
    async getOrganList() {
      if (!this.schoolInfo || !this.schoolInfo.name) {
        return;
      }

      await axiosRequest(
        "/zlf/organ-list",
        { id: this.id, type: 0 },
        axiosOptions("post", "", "json")
      )
        .then((res) => {
          if (
            res &&
            res.data.code === 200 &&
            res.data.data &&
            res.data.data.length > 0
          ) {
            const myChart = echarts.init(document.getElementById("chartsCxy"));

            const data = [
                {
                  name: this.schoolInfo.name,
                  fixed: true,
                  x: myChart.getWidth() / 2,
                  y: myChart.getHeight() / 2,
                  id: "-1",
                  //symbol: "image:///images/360_4.png",
                  label: {
                    color: "#5470c6",
                    fontWeight: "bold",
                    fontSize: 14,
                  },
                  itemStyle: {
                    color: "#5470c6",
                  },
                  symbolSize: 20,
                },
              ],
              edges = [];

            res.data.data.forEach((item) => {
              data.push({
                id: item.id,
                name: item.name,
                //symbol: "image:///images/360_5.png",
                itemStyle: {
                  color:
                    item.type === 0
                      ? "#35a5ff"
                      : item.type === 1
                      ? "goldenrod"
                      : "#a9748f",
                },
              });
              edges.push({
                source: item.id,
                target: "-1",
                label: {
                  show: true,
                  formatter:
                    item.type === 0
                      ? "合作机构"
                      : item.type === 1
                      ? "机构层级"
                      : "工作",
                },
              });
            });

            myChart.setOption({
              series: [
                {
                  type: "graph",
                  layout: "force",
                  animation: false,
                  roam: true,
                  label: {
                    show: true,
                    color: "#000",
                    position: "bottom",
                  },
                  // symbolSize: 0,
                  zoom: 3,
                  data: data,
                  force: {
                    // initLayout: 'circular'
                    // gravity: 0
                    repulsion: 100,
                    edgeLength: 5,
                  },
                  edges: edges,
                },
              ],
            });
          }
        })
        .catch(() => {});
    },
    async getInventorFacet() {
      if (!this.schoolInfo || !this.schoolInfo.name) {
        return;
      }

      await axiosRequest(
        "/patent/inventor-facet",
        {
          keyword: this.schoolInfo.name,
        },
        axiosOptions("post", "", "json")
      )
        .then((res) => {
          if (res && res.data.code === 200) {
            this.inventorFacetData = res.data.data;
          }
        })
        .catch((error) => {});
    },
    async getArticleYearsFacet() {
      if (!this.schoolInfo || !this.schoolInfo.name) {
        return;
      }

      await axiosRequest(
        "/zlf/years-facet",
        {
          keyword: this.schoolInfo.name,
          id: 0,
          type: 0,
        },
        axiosOptions("post", "", "json")
      )
        .then((res) => {
          if (res && res.data.code === 200) {
            this.articleYearsFacet = res.data.data;
          }
        })
        .catch((error) => {});
    },
    async getPatentYearsFacet() {
      if (!this.schoolInfo || !this.schoolInfo.name) {
        return;
      }

      await axiosRequest(
        "/patent/years-facet",
        {
          keyword: this.schoolInfo.name,
          type: 0,
        },
        axiosOptions("post", "", "json")
      )
        .then((res) => {
          if (res && res.data.code === 200) {
            this.patentYearsFacet = res.data.data;
          }
        })
        .catch((error) => {});
    },
    handleScrollIntoView(index) {
      document.getElementById("catalog").className = "catalog";
      this.catalogActive = index;
      document
        .getElementById("catalogContent" + index)
        .scrollIntoView({ behavior: "smooth" });
    },
    replaceCompanyName(name) {
      if (name) {
        return name
          .replace(/<.*?>/g, "")
          .replace("（", "")
          .replace("）", "")
          .replace("(", "")
          .replace(")", "");
      }
      return "";
    },
    formatJsbjText() {
      return (percentage) => {
        return "超过同行\n\n" + percentage + "%";
      };
    },
    async getCompanyInfo() {
      this.contentLoading = true;
      await axiosRequest(
        "/school/detail",
        { id: this.id },
        axiosOptions("post", "", "json")
      )
        .then((response) => {
          this.contentLoading = false;
          if (response && response.data.data) {
            this.schoolInfo = response.data.data.item1;
            this.schoolDetail = response.data.data.item2;
          }
        })
        .catch((error) => {
          this.contentLoading = false;
        });
    },
    async getCompanyPatent() {
      if (!this.schoolInfo || !this.schoolInfo.name) {
        return;
      }

      await axiosRequest(
        "/patent/company-patent",
        {
          company: this.schoolInfo.name,
          pageIndex: this.patentPageIndex,
          pageSize: this.patentPageSize,
        },
        axiosOptions("post", "", "json")
      )
        .then((response) => {
          if (response && response.data.data) {
            this.patentResults = response.data.data.results;
            this.patentTotal = response.data.data.totalCount;
          }
        })
        .catch((error) => {});
    },
    patentIndexMethod(index) {
      return (this.patentPageIndex - 1) * this.patentPageSize + 1 + index;
    },
    formatDate(value) {
      if (!value) {
        return "";
      }
      return moment(value).format("YYYY-MM-DD");
    },
    handlePatentCurrentChange(currentPage) {
      this.tabLoading = true;
      this.patentPageIndex = currentPage;
      this.getCompanyPatent().then(() => {
        this.tabLoading = false;
      });
    },
  },
};
</script>

<style lang="scss">
.el-image-viewer__wrapper {
  .el-image-viewer__mask {
    opacity: 0.9;
  }
  .el-image-viewer__canvas {
    .el-image-viewer__img {
      max-width: 70% !important;
      max-height: 70% !important;
    }
  }
}
.img-viewer-title {
  position: fixed;
  left: 10%;
  top: 25px;
  z-index: 9999;
  color: #fff;
  width: 80%;
  @media screen and (max-width: 768px) {
    width: 65%;
  }
}
.img-viewer-download {
  position: fixed;
  right: 40px;
  bottom: 50px;
  z-index: 9999;
}
.z-index-9999 {
  z-index: 9999 !important;
}
</style>
<style lang="scss" scoped>
@import "@/assets/css/var.scss";
@import "@/assets/css/guid.scss";
@import "@/assets/css/search.scss";

.data-list {
  overflow-y: auto;

  ::v-deep dl {
    cursor: unset;
    dt {
      a {
        max-width: 355px;
      }
    }
    // 图片加载中效果
    .pic {
      cursor: pointer;

      .el-image__placeholder {
        background: url("~@/assets/images/loading.gif") no-repeat center;
        position: absolute;
        top: 0;
      }
    }
  }
}
</style>
